import {useCallback, useState, useSyncExternalStore} from 'react'

const getServerSnapshot = () => false

export function useMergeabilityDegradationHint({
  identity,
  isCalculating,
  circuitBreakerOpen,
  observedAt,
  lastPositiveAt,
}: {
  identity: string
  isCalculating: boolean
  circuitBreakerOpen: boolean | undefined
  observedAt: number
  lastPositiveAt?: number
}) {
  const [observation, setObservation] = useState({
    identity,
    lastTrueAt: isCalculating ? (lastPositiveAt ?? (circuitBreakerOpen === true ? observedAt : undefined)) : undefined,
  })

  if (observation.identity !== identity || (!isCalculating && observation.lastTrueAt !== undefined)) {
    setObservation({identity, lastTrueAt: isCalculating && circuitBreakerOpen === true ? observedAt : undefined})
  } else if (isCalculating && circuitBreakerOpen === true && observation.lastTrueAt !== observedAt) {
    setObservation({identity, lastTrueAt: observedAt})
  }

  const lastTrueAt = observation.lastTrueAt
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (lastTrueAt === undefined) return () => {}
      const timeout = setTimeout(onChange, Math.max(0, lastTrueAt + 60_000 - Date.now()))
      return () => clearTimeout(timeout)
    },
    [lastTrueAt],
  )
  const getSnapshot = useCallback(() => lastTrueAt !== undefined && Date.now() < lastTrueAt + 60_000, [lastTrueAt])
  // Subscribe to expiry as an external clock so cached hints cannot flash and SSR stays deterministic.
  const isRecent = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return isCalculating && observation.identity === identity && isRecent
}
